import * as Yup from "yup";

export const validationLogin = (text: any) => Yup.object({
  email: Yup.string().email(text["Invalid email address"]).required(text["Required"]),
  password: Yup.string().required(text["Required"]),
});
